import React from 'react';


function LogoTicker() {
  return (
    <>
    <section className="relative overflow-hidden z-10">
        <div className="container logo-ticker mb-4.5 md:mb-6">
            <p className="font-main text-[#232632] text-16 md:text-[22px] mt-4 md:mt-1 md:mb-[38px] text-center font-medium tracking-normal opacity-90 w-4/5 md:w-full mx-auto leading-[26px]">
            Deployed for <span className="font-bold">350,000+</span> agents in <span className="font-bold">70+</span> world leading enterprises
            </p>
            <div className="slider flex items-center justify-start overflow-hidden">
                <div className="logo_shadow"></div>
                <div className="logo_shadow right"></div>
                <div className="slide-track flex items-center justify-start">
                    <img src="/img/logo/bhhc.svg" alt="BHHC" width="170px"/>
                    <img src="/img/logo/hdfc.svg" alt="HDFC Bank" width="160px" />
                    <img src="/img/us/kemper.png" alt="kemper" width="105px" />
                    <img src="/img/logo/generali.svg" alt="Generali" width="140px"/>
                    <img src="/img/logo/aia.svg" alt="AIA" width="65px" />
                    <img src="/img/logo/sun-life-dark.png" alt="Sun Life" width="95px" />
                    <img src="/img/logo/axa.svg" alt="AXA" width="65px" />
                </div>
                <div className="slide-track flex items-center justify-start">
                    <img src="/img/logo/bhhc.svg" alt="BHHC" width="170px"/>
                    <img src="/img/logo/hdfc.svg" alt="HDFC Bank" width="160px" />
                    <img src="/img/us/kemper.png" alt="kemper" width="105px" />
                    <img src="/img/logo/generali.svg" alt="Generali" width="140px"/>
                    <img src="/img/logo/aia.svg" alt="AIA" width="65px" />
                    <img src="/img/logo/sun-life-dark.png" alt="Sun Life" width="95px" />
                    <img src="/img/logo/axa.svg" alt="AXA" width="65px" />
                </div>
            </div>
        </div>
    </section>
    </>
  );
}

export default LogoTicker;
